import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { throttle } from '../../../helpers/utils';


const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        marginTop: 20,
        [theme.breakpoints.down('sm')]: {
            padding: 15,
            marginTop: 10,
        },
    },
    heading: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            padding: 4,
            marginTop: 10,
            flexDirection: 'column',
        },
    },
    container: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
    },
    title: {
        [theme.breakpoints.down('md')]: {
            fontSize: '1.9rem',
        },
    },
    inputs: {
        display: 'flex',
        flexDirection: 'column',
        width: '260px',
    },
}));


export default function Members() {

    const [initialState, setMembersList] = useState([])
    const sheetURL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS_fBlEotiPV2iW9TVPlMeES4l8fqVOB1krJkIIMJ0DIvLelKo_X38TLt__-aPFAGHHSSc7uDeTvsoq/pub?gid=0&single=true&output=tsv'

    useEffect(() => {
        fetch(sheetURL)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Ошибка загрузки списка участников: ${response.status}`);
                }
                return response.text();
            })
            .then(data => {
                const dataList = data
                    .replace(/^\uFEFF/, '')
                    .split(/\r\n|\n|\r/)
                    .slice(1)
                    .map(line => line.split('\t').map(cell => cell.trim()))
                    .filter(([name]) => name)
                    .map(([name, title, organization, city, section]) => ({
                        name,
                        title,
                        from: [organization, city].filter(Boolean).join(', '),
                        section,
                    }));
                setMembersList(dataList)
                setMembers(dataList)
            })
            .catch(error => {
                console.error('Произошла ошибка:', error);
            });
    }, [])


    const classes = useStyles();
    const [members, setMembers] = useState(initialState);
    const filterMember = (e) => {
        const variant = e.currentTarget.id === 'search-name' ? 'name' : 'title';

        const value = e.target.value || '';
        const copy = [...initialState];
        if (variant === 'name') {
            setMembers(copy.filter((el) => el.name && el.name.search(new RegExp(value, 'ig')) !== -1));
        } else {
            setMembers(copy.filter((el) => el.title && el.title.search(new RegExp(value, 'ig')) !== -1));
        }
    };

    return (
        <Container maxWidth='lg' className={classes.container}>
            <Paper className={classes.paper}>
                <Box p={4} className={classes.heading}>
                    <Typography variant='h3' className={classes.title}>
                        Принятые заявки: {initialState.length}
                    </Typography>
                    <Box className={classes.inputs}>
                        <TextField
                            id='search-name'
                            size='small'
                            fullWidth
                            onChange={throttle(filterMember, 400)}
                            label='Поиск по фамилии'
                        />
                        <TextField
                            id='search-body'
                            size='small'
                            fullWidth
                            onChange={filterMember}
                            label='Поиск по названию'
                        />
                    </Box>
                </Box>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">№</TableCell>
                                <TableCell align="left">ФИО</TableCell>
                                <TableCell align="left">Место работы (учебы)</TableCell>
                                <TableCell align="left">Название доклада</TableCell>
                                <TableCell align="right">Секция</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {members.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell component='th' scope='row'>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell align="left">{row.from}</TableCell>
                                    <TableCell align="left">{row.title}</TableCell>
                                    <TableCell align="left">{row.section}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Container>
    );
}
